import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import {
  Container, Typography, Button, Box, Paper,
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField,
  Chip, MenuItem, Select, FormControl, InputLabel
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

//const API = 'https://geo-energy-tech.com';
//const API = 'http://localhost:8000';
const API = process.env.REACT_APP_API_URL;

const coloresPrioridad = {
  baja: 'default',
  media: 'primary',
  alta: 'error'
};

export default function Tareas() {
  const { usuario } = useAuth();
  const [tareas, setTareas] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    titulo: '',
    descripcion: '',
    estado: 'pendiente',
    prioridad: 'media',
    proyecto_id: '',
    asignado_a: usuario?.id
  });

const cargarDatos = () => {
  axios.get(`${API}/api/tareas`, { params: { empresa_id: usuario?.empresa_id } })
    .then(r => setTareas(Array.isArray(r.data) ? r.data : []))
    .catch(() => setTareas([]));
  axios.get(`${API}/api/proyectos`, { params: { empresa_id: usuario?.empresa_id } })
    .then(r => setProyectos(Array.isArray(r.data) ? r.data : []))
    .catch(() => setProyectos([]));
  axios.get(`${API}/api/usuarios`, { params: { empresa_id: usuario?.empresa_id } })
    .then(r => setUsuarios(Array.isArray(r.data) ? r.data : []))
    .catch(() => setUsuarios([]));
};

  useEffect(() => { cargarDatos(); }, []);

  const crearTarea = async () => {
    await axios.post(`${API}/api/tareas`, {
      ...form,
      proyecto_id: form.proyecto_id || null,
      asignado_a: form.asignado_a || null,
      empresa_id: usuario?.empresa_id || null
    });
    setForm({
      titulo: '',
      descripcion: '',
      estado: 'pendiente',
      prioridad: 'media',
      proyecto_id: '',
      asignado_a: usuario?.id
    });
    setOpen(false);
    cargarDatos();
  };

  const cambiarEstado = async (id, estado) => {
    await axios.patch(`${API}/api/tareas/${id}/estado?estado=${estado}`);
    cargarDatos();
  };

  const eliminarTarea = async (id) => {
    if (window.confirm('¿Eliminar esta tarea?')) {
      await axios.delete(`${API}/api/tareas/${id}`);
      cargarDatos();
    }
  };

  const getNombreUsuario = (id) => {
    const u = usuarios.find(u => u.id === id);
    return u ? u.nombre : '—';
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4">Tareas</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpen(true)}
        >
          Nueva Tarea
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><b>Título</b></TableCell>
              <TableCell><b>Proyecto</b></TableCell>
              <TableCell><b>Asignado a</b></TableCell>
              <TableCell><b>Prioridad</b></TableCell>
              <TableCell><b>Estado</b></TableCell>
              <TableCell><b>Acciones</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tareas.map(t => (
              <TableRow key={t.id}>
                <TableCell>{t.titulo}</TableCell>
                <TableCell>
                  {proyectos.find(p => p.id === t.proyecto_id)?.nombre || '—'}
                </TableCell>
                <TableCell>
                  {t.asignado_a ? (
                    <Chip
                      label={getNombreUsuario(t.asignado_a)}
                      size="small"
                      color="secondary"
                      variant="outlined"
                    />
                  ) : '—'}
                </TableCell>
                <TableCell>
                  <Chip
                    label={t.prioridad}
                    color={coloresPrioridad[t.prioridad]}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <FormControl size="small">
                    <Select
                      value={t.estado}
                      onChange={e => cambiarEstado(t.id, e.target.value)}
                    >
                      <MenuItem value="pendiente">Pendiente</MenuItem>
                      <MenuItem value="en_progreso">En Progreso</MenuItem>
                      <MenuItem value="completada">Completada</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  {usuario?.rol === 'admin' && (
                    <Button
                      color="error"
                      startIcon={<DeleteIcon />}
                      onClick={() => eliminarTarea(t.id)}
                    >
                      Eliminar
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {tareas.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No hay tareas aún
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog crear tarea */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>Nueva Tarea</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth label="Título" value={form.titulo}
            onChange={e => setForm({ ...form, titulo: e.target.value })}
            sx={{ mb: 2, mt: 1 }}
          />
          <TextField
            fullWidth label="Descripción" value={form.descripcion}
            onChange={e => setForm({ ...form, descripcion: e.target.value })}
            multiline rows={2} sx={{ mb: 2 }}
          />
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Proyecto</InputLabel>
            <Select
              value={form.proyecto_id}
              label="Proyecto"
              onChange={e => setForm({ ...form, proyecto_id: e.target.value })}
            >
              <MenuItem value="">— Sin proyecto —</MenuItem>
              {proyectos.map(p => (
                <MenuItem key={p.id} value={p.id}>{p.nombre}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Asignado a</InputLabel>
            <Select
              value={form.asignado_a}
              label="Asignado a"
              onChange={e => setForm({ ...form, asignado_a: e.target.value })}
            >
              <MenuItem value="">— Sin asignar —</MenuItem>
              {usuarios.map(u => (
                <MenuItem key={u.id} value={u.id}>{u.nombre}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Prioridad</InputLabel>
            <Select
              value={form.prioridad}
              label="Prioridad"
              onChange={e => setForm({ ...form, prioridad: e.target.value })}
            >
              <MenuItem value="baja">Baja</MenuItem>
              <MenuItem value="media">Media</MenuItem>
              <MenuItem value="alta">Alta</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Estado</InputLabel>
            <Select
              value={form.estado}
              label="Estado"
              onChange={e => setForm({ ...form, estado: e.target.value })}
            >
              <MenuItem value="pendiente">Pendiente</MenuItem>
              <MenuItem value="en_progreso">En Progreso</MenuItem>
              <MenuItem value="completada">Completada</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button variant="contained" onClick={crearTarea}>Crear</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}